import { render, staticRenderFns } from "./ParsingGroupForm.vue?vue&type=template&id=4c109e16"
import script from "./ParsingGroupForm.vue?vue&type=script&lang=js"
export * from "./ParsingGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports